import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Result } from 'antd';
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Footer from '../components/Footer';
import './LoginPage.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3060/api';

function ForgotPasswordPage() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [submittedEmail, setSubmittedEmail] = useState(null);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${API_BASE}/auth/forgot-password`, {
        email: values.email.trim()
      });
      if (data.success) {
        setSubmittedEmail(values.email.trim());
      } else {
        message.error(data.error || '申请失败');
      }
    } catch (err) {
      message.error(err.response?.data?.error || '申请失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  if (submittedEmail) {
    return (
      <div className="login-container">
        <Card className="login-card">
          <Result
            status="success"
            title="重置链接已发送"
            subTitle={
              <span>
                如果 <strong>{submittedEmail}</strong> 已绑定有效账号，您将很快收到重置邮件。<br />
                链接有效期 30 分钟，请尽快操作。
              </span>
            }
            extra={[
              <Link to="/login" key="login">
                <Button type="primary">返回登录</Button>
              </Link>
            ]}
          />
          <Footer className="card-footer" centered={true} />
        </Card>
      </div>
    );
  }

  return (
    <div className="login-container">
      <Card className="login-card" title="找回密码">
        <p style={{ color: '#666', fontSize: 13, marginTop: -8, marginBottom: 20 }}>
          请输入账号绑定的邮箱，系统将发送密码重置链接到该邮箱。
        </p>
        <Form
          form={form}
          name="forgot-password"
          onFinish={handleSubmit}
          size="large"
          className="login-form"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: '请输入邮箱' },
              { type: 'email', message: '请输入有效的邮箱地址' }
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="邮箱地址"
              autoComplete="email"
              onPressEnter={() => form.submit()}
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-button"
              loading={loading}
              block
            >
              发送重置链接
            </Button>
          </Form.Item>

          <div style={{ textAlign: 'center', marginTop: -8 }}>
            <Link to="/login" style={{ fontSize: 13 }}>
              <ArrowLeftOutlined /> 返回登录
            </Link>
          </div>
        </Form>

        <Footer className="card-footer" centered={true} />
      </Card>
    </div>
  );
}

export default ForgotPasswordPage;
